import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { ISettingSystem } from 'app/interface/ISetting'

import { initialSettingSystem } from '../initialState'

const settingSlice = createSlice({
  name: 'settingAdmin',
  initialState: initialSettingSystem,
  reducers: {
    updateSetting: (state: ISettingSystem, action: PayloadAction<{ key: string; value: string }[]>): ISettingSystem => {
      const setting = action.payload.reduce((acc: ISettingSystem, curr: { key: string; value: string }) => {
        acc[curr.key as keyof ISettingSystem] = curr
        return acc
      }, state)
      return setting
    },
  },
  extraReducers: () => {},
})

export const settingActions = settingSlice.actions
export default settingSlice
